import { useSearch } from '@tribeplatform/react-sdk/hooks'
import { getSearchKey } from '@tribeplatform/react-sdk/utils/keys'

import { useDebounce } from '../../common/hooks/useDebounce.js'
import { useI18n } from '../../i18n/providers/I18nProvider.js'
import { getSearchItemLink } from '../../Search/utils.js'
import { cleanSearchQuery } from '../../utils/search.js'
import { CommandBarHookResult, emptyCommandBarResult } from '../types.js'

export const useCommandBarSearch: CommandBarHookResult = ({
  query: dirtyQuery,
}) => {
  const { $t } = useI18n()
  const query = cleanSearchQuery(dirtyQuery)

  const debouncedQuery = useDebounce(query, 100)

  const generatedQuery = `${debouncedQuery} +for:post`

  const { data: searchData, isInitialLoading } = useSearch({
    variables: {
      input: {
        query: debouncedQuery ? generatedQuery : null,
      },
    },
    fields: { in: 'basic' },
    useQueryOptions: {
      queryKey: getSearchKey({
        variables: {
          input: { query: debouncedQuery ? generatedQuery : null },
        },
      }),
      keepPreviousData: true,
      enabled: query?.length > 1,
    },
  })

  if (!query) {
    return emptyCommandBarResult
  }

  const posts = searchData?.hits?.[0]?.hits || []
  if (!posts?.length) {
    return emptyCommandBarResult
  }

  const categoryTexts = {
    search: $t({
      id: 'Generics.Search',
      defaultMessage: 'Search',
    }),
  } as const

  return {
    isLoading: isInitialLoading,
    actions:
      posts?.map(post => {
        return {
          name: post.title,
          url: getSearchItemLink(post),
          icon: 'post',
          category: categoryTexts.search,
        }
      }) || [],
  }
}
